import api from 'Application/api/api';

const deleteProjectCustomTopic = (projectId, customTopicId, cancelToken = null) =>
    api.delete(`project-manager/projects/${projectId}/custom-topics/${customTopicId}`, {
        cancelToken,
    });

export default deleteProjectCustomTopic;
